module.exports = __webpack_public_path__ + "img/hkht.eff00a6.png";